import { apiClient } from './api';
import { API_ENDPOINTS } from '../constants';

/** Acepta distintas formas de payload (array, { data }, { results }, anidados). */
function normalizeClientsPayload(payload) {
  if (payload == null) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.data)) return payload.data;
  if (payload.data && Array.isArray(payload.data.results)) return payload.data.results;
  if (Array.isArray(payload.results)) return payload.results;
  if (payload.data && Array.isArray(payload.data.clients)) return payload.data.clients;
  if (Array.isArray(payload.clients)) return payload.clients;
  return [];
}

export const clientService = {
  async getClients(filters = {}) {
    const params = new URLSearchParams();
    
    // Agregar parámetros de paginación
    if (filters.page) {
      params.append('page', filters.page.toString());
    }
    if (filters.page_size) {
      params.append('page_size', filters.page_size.toString());
    }
    
    // Agregar otros filtros
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '' && key !== 'page' && key !== 'page_size') {
        params.append(key, value.toString());
      }
    });
    
    const queryString = params.toString();
    const endpoint = queryString ? `${API_ENDPOINTS.CLIENTS}?${queryString}` : API_ENDPOINTS.CLIENTS;
    
    const response = await apiClient.get(endpoint);

    if (response?.success && response.data != null) {
      return normalizeClientsPayload({ data: response.data });
    }

    return normalizeClientsPayload(response);
  },

  async getClient(id) {
    const response = await apiClient.get(API_ENDPOINTS.CLIENT_DETAIL(id));
    
    // Extraer los datos de la respuesta estructurada
    if (response && response.success && response.data) {
      return response.data;
    }
    
    // Fallback: si la respuesta no tiene la estructura esperada, devolver la respuesta completa
    return response;
  },

  async createClient(data) {
    const response = await apiClient.post(API_ENDPOINTS.CLIENTS, data);
    
    // Extraer los datos de la respuesta estructurada
    if (response && response.success && response.data) {
      return response.data;
    }
    
    return response;
  },

  async updateClient(id, data) {
    return apiClient.put(API_ENDPOINTS.CLIENT_DETAIL(id), data);
  },

  async deleteClient(id) {
    return apiClient.delete(API_ENDPOINTS.CLIENT_DETAIL(id));
  },

  async bulkUpdateClients(ids, updates) {
    return apiClient.patch(`${API_ENDPOINTS.CLIENTS}bulk_update/`, {
      ids,
      updates,
    });
  },

  async exportClients(filters) {
    const params = new URLSearchParams();
    
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, value.toString());
        }
      });
    }
    
    const queryString = params.toString();
    const endpoint = queryString ? `${API_ENDPOINTS.CLIENTS}export/?${queryString}` : `${API_ENDPOINTS.CLIENTS}export/`;
    
    const response = await fetch(`${apiClient['baseURL']}${endpoint}`, {
      headers: {
        'Authorization': `Bearer ${apiClient.getToken()}`,
      },
    });
    
    if (!response.ok) {
      throw new Error('Failed to export clients');
    }
    
    return response.blob();
  },
};
